import React, { Component } from 'react';

export class About extends Component {
  static displayName = About.name;

  render () {
    return (
        <div>
            <div class="profile-content">
                <div class="head">   
                    <div style={{ 
                        backgroundImage: 'url(https://about.me/cdn-cgi/image/q=40,dpr=2,f=auto,fit=cover,w=620,h=413.3333333333333,gravity=0.269x0.037/https://assets.about.me/background/users/r/y/a/ryancouch_1613582355_648.jpg)',
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center center',
                        paddingBottom: '66%'
                    }}></div>
                    <div class="name-headline">
                        <section><h1 class="name">Ryan Couch</h1></section>
                        <section><h2 class="headline">
                            <span class="roles">
                                <span class="role">Senior Software Engineer</span>
                                </span> 
                                <span class="location">in <span class="location">Rogers, Arkansas</span>
                                </span>
                        </h2>
                        </section>
                    </div>
                </div>
                <div class="body">
                    <div class="body-content">
                        <section class="spotlight inset">
                            <a href="https://github.com/rcouch00/Ryan.Couch/blob/main/Ryan%20Couch%20-%20Resume.pdf" target="_blank" rel="nofollow noopener noreferrer" class="button xlarge dark primary glyph-hireme"
                            style={{ 
                                backgroundColor: 'rgb(48, 91, 144)',
                                borderColor: 'rgb(48, 91, 144)',
                                lineHeight: '1.5',
                                color: 'rgb(180, 174, 166)',
                                textAlign: 'center',
                                fontWeight: 'inherit',
                                fontStyle: 'inherit',
                                fontSize: '100%',
                                fontFamily: 'inherit',
                                boxSizing: 'border-box',
                                padding: '0 20px',
                                maxWidth: '440px',
                                width: '100%',
                            }}>
                                <span class="text ellipsis">Resume</span>
                            </a>
                        </section>
                        <section class="bio inset">
                            <div>
                                <p>I am a senior software engineer currently living in Rogers, Arkansas. My interests range from technology to motorcycles. I am also interested in finance, investing, education, video games, sailing and Arduino's.</p>
                                <p>I still can't believe I get paid to do what I enjoy. I expect excellence of myself and won't settle for less. I take pride in the work I do every day. I look forward to the problems I will solve tomorrow... and the laughs I'll have along the way!</p>
                                <p>You can click the button above to view my resume and contact information.</p>
                                <p>-----------------------------------------------------------------</p>
                                <p>learn(n*share(n,learn(n+1)))<br/></p>
                                <p>Learn, Share, Grow</p>
                                <p>-----------------------------------------------------------------</p>
                                <p>There's a frood who really knows where his towel is.</p>
                            </div>
                        </section>
                        <section class="social-links inset">
                            <ul class="inline">
                                <li>
                                    <a class="social-link" title="Visit me on LinkedIn" href="https://www.linkedin.com/in/ryancouch/" target="_blank" rel="noopener noreferrer">
                                        <span class="SVGInline">
                                            <svg class="SVGInline-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000">
                                                <path d="M1000 500c0 277-223 500-500 500S0 777 0 500 223 0 500 0s500 223 500 500zM375 260c-1-41-32-73-83-73-50 0-83 32-83 73s32 73 82 73h1c51 0 83-32 83-73zm-21 136H229v354h125V396zm458 166c0-114-56-187-146-187-50 0-87 30-104 75l-4-54H434c1 13 3 83 3 83v271h125V562c0-50 23-83 62-83 38 0 63 20 63 83v188h125V562z"></path>
                                            </svg>
                                        </span>
                                    </a>
                                </li>
                            </ul>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    );
  }
}
